import Translator from '../../classes/Translator/Translator';
const AboutEgreenLogic = () => {
    const { translator } = Translator();

    return {
        translator,
    };
};
export default AboutEgreenLogic;


